export const EMAIL_TEMPLATE_KEYS = {
  // 1. User Registration & Account Management
  WELCOME_EMAIL: 'welcome-email',
  EMAIL_VERIFICATION: 'email-verification',
  OTP_VERIFICATION: 'otp-verification',
  ACCOUNT_SUCCESSFULLY_CREATED: 'account-successfully-created',
  PROFILE_COMPLETION_REMINDER: 'profile-completion-reminder',
  PASSWORD_RESET_REQUEST: 'password-reset-request',
  PASSWORD_RESET_SUCCESSFUL: 'password-reset-successful',
  PASSWORD_CHANGED_NOTIFICATION: 'password-changed-notification',
  EMAIL_ADDRESS_CHANGED: 'email-address-changed',
  PHONE_NUMBER_CHANGED: 'phone-number-changed',
  TWO_FACTOR_AUTHENTICATION_ENABLED_DISABLED:
    'two-factor-authentication-enabled-disabled',
  SUSPICIOUS_LOGIN_ALERT: 'suspicious-login-alert',
  NEW_DEVICE_LOGIN_ALERT: 'new-device-login-alert',
  MULTIPLE_FAILED_LOGIN_ATTEMPT_ALERT: 'multiple-failed-login-attempt-alert',
  ACCOUNT_LOCKED_NOTIFICATION: 'account-locked-notification',
  ACCOUNT_UNLOCKED_NOTIFICATION: 'account-unlocked-notification',
  ACCOUNT_DEACTIVATION_NOTICE: 'account-deactivation-notice',
  ACCOUNT_REACTIVATION_NOTICE: 'account-reactivation-notice',
  ACCOUNT_DELETION_CONFIRMATION: 'account-deletion-confirmation',
  TERMS_AND_PRIVACY_POLICY_UPDATE: 'terms-and-privacy-policy-update',

  // 2. Orders, Billing & Payment (No Shipping Flow)
  // Order & Invoice
  ORDER_CONFIRMATION: 'order-confirmation',
  ORDER_PROCESSING: 'order-processing',
  ORDER_CANCELLED: 'order-cancelled',
  ORDER_REFUNDED: 'order-refunded',
  PARTIAL_REFUND_CONFIRMATION: 'partial-refund-confirmation',
  INVOICE_GENERATED: 'invoice-generated',
  UPDATED_INVOICE: 'updated-invoice',
  INVOICE_PAYMENT_REMINDER: 'invoice-payment-reminder',
  MANUAL_PAYMENT_CONFIRMATION: 'manual-payment-confirmation',

  ITEM_CONFIRMATION: 'item-confirmation', // one-time item purchase
  DESIGN_CONFIRMATION: 'design-confirmation', // design item purchase

  // Payment Events
  PAYMENT_SUCCESSFUL: 'payment-successful',
  PAYMENT_FAILED: 'payment-failed',
  PAYMENT_PENDING: 'payment-pending',
  AUTO_DEBIT_SUCCESSFUL: 'auto-debit-successful',
  AUTO_DEBIT_FAILED: 'auto-debit-failed',
  CARD_EXPIRY_REMINDER: 'card-expiry-reminder',
  PAYMENT_METHOD_UPDATED: 'payment-method-updated',
  TRANSACTION_RECEIPT: 'transaction-receipt',

  // 3. Subscription & SaaS
  SUBSCRIPTION_ACTIVATED: 'subscription-activated',
  SUBSCRIPTION_UPGRADE_CONFIRMATION: 'subscription-upgrade-confirmation',
  SUBSCRIPTION_DOWNGRADE_CONFIRMATION: 'subscription-downgrade-confirmation',
  SUBSCRIPTION_RENEWED: 'subscription-renewed',
  UPCOMING_RENEWAL_REMINDER: 'upcoming-renewal-reminder',
  SUBSCRIPTION_UPGRADE_REMINDER: 'subscription-upgrade-reminder',
  SUBSCRIPTION_PAYMENT_FAILED: 'subscription-payment-failed',
  GRACE_PERIOD_NOTIFICATION: 'grace-period-notification',
  SUBSCRIPTION_SUSPENDED: 'subscription-suspended',
  SUBSCRIPTION_CANCELLED: 'subscription-cancelled',
  SUBSCRIPTION_EXPIRED: 'subscription-expired',
  SUBSCRIPTION_REACTIVATED: 'subscription-reactivated',
  MISSED_PAYMENT_PAUSED: 'missed-payment-paused',
  MISSED_PAYMENT_ON_HOLD: 'missed-payment-on-hold',
  MISSED_PAYMENT_CANCELLED: 'missed-payment-cancelled',

  // 4. Engagement & Retention
  ABANDONED_CART_REMINDER: 'abandoned-cart-reminder',
  ABANDONED_CHECKOUT_REMINDER: 'abandoned-checkout-reminder',
  INACTIVE_USER_7_DAYS: 'inactive-user-7-days',
  INACTIVE_USER_30_DAYS: 'inactive-user-30-days',
  SPECIAL_OFFER_FOR_EXISTING_USERS: 'special-offer-for-existing-users',
  ANNIVERSARY_EMAIL: 'anniversary-email',
  BIRTHDAY_EMAIL: 'birthday-email',

  // 5. Marketing & Promotional
  NEWSLETTER: 'newsletter',
  BLOG_UPDATE: 'blog-update',
  FEATURE_RELEASE_ANNOUNCEMENT: 'feature-release-announcement',
  PRODUCT_UPDATE_ANNOUNCEMENT: 'product-update-announcement',
  SERVICE_LAUNCH_ANNOUNCEMENT: 'service-launch-announcement',
  LIMITED_TIME_OFFER: 'limited-time-offer',
  FLASH_SALE: 'flash-sale',
  EARLY_ACCESS_INVITE: 'early-access-invite',
  SEASONAL_CAMPAIGN: 'seasonal-campaign',
  REFERRAL_PROGRAM_INVITATION: 'referral-program-invitation',
  REFERRAL_REWARD_NOTIFICATION: 'referral-reward-notification',
  EVENT_INVITATION: 'event-invitation',
  SURVEY_CAMPAIGN: 'survey-campaign',
  FEEDBACK_COLLECTION_CAMPAIGN: 'feedback-collection-campaign',

  // 6. System, Hosting & Security Alerts
  WEBSITE_DOWN_ALERT: 'website-down-alert',
  WEBSITE_RESTORED_NOTIFICATION: 'website-restored-notification',
  SERVER_MAINTENANCE_SCHEDULED: 'server-maintenance-scheduled',
  EMERGENCY_MAINTENANCE_NOTICE: 'emergency-maintenance-notice',
  BACKUP_SUCCESSFUL: 'backup-successful',
  BACKUP_FAILED: 'backup-failed',
  MALWARE_DETECTED: 'malware-detected',
  MALWARE_REMOVED_CONFIRMATION: 'malware-removed-confirmation',
  SSL_EXPIRY_REMINDER: 'ssl-expiry-reminder',
  SSL_INSTALLED_CONFIRMATION: 'ssl-installed-confirmation',
  DOMAIN_EXPIRY_REMINDER: 'domain-expiry-reminder',
  DOMAIN_RENEWAL_CONFIRMATION: 'domain-renewal-confirmation',
  HOSTING_EXPIRY_REMINDER: 'hosting-expiry-reminder',
  HOSTING_RENEWAL_CONFIRMATION: 'hosting-renewal-confirmation',
  SECURITY_PATCH_APPLIED: 'security-patch-applied',
  DATA_EXPORT_READY: 'data-export-ready',
  SUSPICIOUS_ACTIVITY_ALERT: 'suspicious-activity-alert',

  // 7. Customer Support
  SUPPORT_TICKET_CREATED: 'support-ticket-created',
  TICKET_ASSIGNED: 'ticket-assigned',
  TICKET_RESPONSE_FROM_SUPPORT: 'ticket-response-from-support',
  WAITING_FOR_CUSTOMER_REPLY: 'waiting-for-customer-reply',
  TICKET_RESOLVED: 'ticket-resolved',
  TICKET_CLOSED: 'ticket-closed',
  FEEDBACK_AFTER_TICKET_CLOSURE: 'feedback-after-ticket-closure',
  COMPLAINT_ESCALATION_NOTICE: 'complaint-escalation-notice',

  // 8. Legal & Compliance
  PRIVACY_POLICY_UPDATE: 'privacy-policy-update',
  TERMS_OF_SERVICE_UPDATE: 'terms-of-service-update',

  // 9. Admin & Internal Notifications — sent to admins, not customers.
  // Whether each one actually fires, and who receives it, is controlled by
  // AdminNotificationSetting (Admin Notifications section in the dashboard).
  ADMIN_NEW_USER_REGISTERED: 'admin-new-user-registered',
  ADMIN_NEW_ORDER_PLACED: 'admin-new-order-placed',
  ADMIN_PAYMENT_FAILED: 'admin-payment-failed',
  ADMIN_SUPPORT_TICKET_CREATED: 'admin-support-ticket-created',
  ADMIN_NEW_SUBSCRIPTION_CREATED: 'admin-new-subscription-created',
};
